<template>
    <auth-layout>
        <confirm-mail />
    </auth-layout>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import AuthLayout from '@/components/entrance/AuthLayout'
import ConfirmMail from '@/components/entrance/ConfirmMail'

import firebase from 'firebase/app'
import 'firebase/auth'

export default {
    components: {
        AuthLayout,
        ConfirmMail
    },
    data() {
        return {
            interval: null
        }
    },
    created() {
        this.startChecking()
    },
    beforeDestroy() {
        this.clearInterval()
    },
    computed: {
        ...mapState(['loadingUser'])
    },
    methods: {
        ...mapActions(['setCurrentUser']),
        startChecking() {
            this.interval = setInterval(async () => {
                const user = firebase.auth().currentUser
                if (!user) return
                await user.reload()
                const refreshedUser = firebase.auth().currentUser
                this.setCurrentUser(refreshedUser)
                this.redirect(refreshedUser)
            }, 3000)
        },
        clearInterval() {
            if (this.interval) {
                clearInterval(this.interval)
                this.interval = null
            }
        },
        redirect(user) {
            if (user && user.emailVerified) {
                this.clearInterval()

                return this.accountType
                    ? this.$router.push({ name: 'basic-info' })
                    : this.$router.push({ name: 'select-profile' })
            }
        }
    }
}
</script>
